// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"b27a9367","455":"e4c85e16","644":"3f5a4d16"}[chunkId] + ".chunk.js";
};